// extracted by mini-css-extract-plugin
module.exports = {"connection":"styles_connection__3Nbo1","row":"styles_row__ypoUd","label":"styles_label__2BBX2","value":"styles_value__1LfHl"};